import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/dist/query/react';
import config from 'config/environment';
import { RootState } from 'store';

const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const state = api.getState() as RootState;

  return await fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders(headers) {
      if (state.user.accessToken) {
        headers.set('authorization', `Bearer ${state.user.accessToken}`);
      }

      return headers;
    },
  })(args, api, extraOptions);
};

export default baseQuery;
